import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { RecManagerLinkComponent } from "@onsip/web/features/shared/components/recManagerLink/rec-manager-link.component";

@NgModule({
  declarations: [RecManagerLinkComponent],
  imports: [CommonModule, RouterModule, PipesModule],
  exports: [RecManagerLinkComponent]
})
export class RecManagerLinkModule {}
